import Router from 'next/router';

import { getQueryParametersFromURL } from '~/techstyle-shared/redux-core';

import { productDetailPath } from '../constants/product';

import { getSecondarySite } from './useSecondarySite';

export function navigateToPathnameFromHref(href: string) {
  const secondarySite = getSecondarySite(Router.asPath);

  // When there's a route prefix (secondary site), we can't use the pathname/query approach
  // because Next.js doesn't have route files like /pages/outlet/products/[identifier].js
  // Instead, we just navigate to the href directly
  if (secondarySite) {
    return Router.push(href);
  }

  // For normal routes without a prefix, use the pathname/query approach for cleaner URLs
  const pathname = href?.includes(`/${productDetailPath}/`)
    ? `/${productDetailPath}/[identifier]`
    : href;

  return Router.push(
    {
      pathname,
      query: getQueryParametersFromURL(href) as any,
    },
    href
  );
}
